module.exports = __webpack_public_path__ + "media/product/p-7-6159d8a3.png";